import Const from 'constants';
import {combineReducers} from 'redux';

let defaultStateOfNonControlledStacks = {
    list: {},
    useStack: false,
    isReset: false,
    isEnabled() {
        return Boolean(this.useStack);
    },
    hasItems() {
        return !isEmpty(this.list);
    },
};

export function nonControlled(state = defaultStateOfNonControlledStacks, action) {
    if (action.type === Const.NHL_NON_CONTROLLED_STACK_IS_USED) {
        state = {...state, useStack: action.data, isReset: false};
    } else if (action.type === Const.SET_NON_CONTROLLED_STACK) {
        state = {...state};
        state.list = {...state.list, ...action.data};
        state = {...state, isReset: false};
    } else if (action.type === Const.SET_NON_CONTROLLED_STACK) {
        delete state.list[action.data];
        state = {...state, isReset: false};
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {...defaultStateOfNonControlledStacks, isReset: true};
    }

    return state;
}

const nhlNameStackItemTemplate = {
    team: '',
    expMin: '',
    players: [],
};

const defaultStateOfNhlNameStack = {
    groups: {
        [Const.NHL_NAME_STACK_FIRST_GROUP]: {
            playersQuantity: Const.NHL_NAME_STACK_MIN_PLAYERS_QUANTITY,
            items: [{...nhlNameStackItemTemplate}],
        },
        [Const.NHL_NAME_STACK_SECOND_GROUP]: {
            playersQuantity: Const.NHL_NAME_STACK_MIN_PLAYERS_QUANTITY,
            items: [{...nhlNameStackItemTemplate}],
        },
    },
    getGroups() {
        return {...this.groups};
    },
    getGroup(groupNumber) {
        return {...this.groups[groupNumber]};
    },
    getFirstGroupItems() {
        return [...this.groups[Const.NHL_NAME_STACK_FIRST_GROUP].items];
    },
    getSecondGroupItems() {
        return [...this.groups[Const.NHL_NAME_STACK_SECOND_GROUP].items];
    },
    getFirstGroupPlayersQuantity() {
        return Number(this.groups[Const.NHL_NAME_STACK_FIRST_GROUP].playersQuantity);
    },
    getSecondGroupPlayersQuantity() {
        return Number(this.groups[Const.NHL_NAME_STACK_SECOND_GROUP].playersQuantity);
    },
    isDoubleStackModeEnabled() {
        return Boolean(this.isDoubleStackMode);
    },
    isDoubleStackMode: false,
    useStack: false,
    isReset: false,
    isEnabled() {
        return Boolean(this.useStack);
    },
};

export function nhlName(state = defaultStateOfNhlNameStack, action) {
    if (action.type === Const.NHL_NAME_STACK_IS_DOUBLE_STACK_MODE) {
        state = {...state, isDoubleStackMode: action.data, isReset: false};
    } else if (action.type === Const.NHL_NAME_STACK_SET_PLAYERS_IN_GROUP) {
        state.groups[action.groupNumber].playersQuantity = action.value;
        state = {...state, isReset: false};
    } else if (action.type === Const.NHL_NAME_STACK_ADD_ITEM) {
        const groups = {...state.groups};
        const items = [...groups[action.groupNumber].items];
        items.push({...nhlNameStackItemTemplate});
        groups[action.groupNumber].items = [...items];
        state = {...state, groups, isReset: false};
    } else if (action.type === Const.NHL_NAME_STACK_REMOVE_ITEM) {
        const groups = {...state.groups};
        const items = [...groups[action.groupNumber].items];
        items.splice(action.itemNumber, 1);
        groups[action.groupNumber].items = [...items];
        state = {...state, groups, isReset: false};
    } else if (action.type === Const.NHL_NAME_STACK_SET_TEAM_TO_ITEM) {
        const groups = {...state.groups};
        const items = [...groups[action.groupNumber].items];
        items[action.itemNumber].team = action.team;
        items[action.itemNumber].players = [];
        groups[action.groupNumber].items = [...items];
        state = {...state, groups, isReset: false};
    } else if (action.type === Const.NHL_NAME_STACK_SET_EXPOSURE_TO_ITEM) {
        const groups = {...state.groups};
        const items = [...groups[action.groupNumber].items];
        items[action.itemNumber].expMin = action.exposure;
        groups[action.groupNumber].items = [...items];
        state = {...state, groups, isReset: false};
    } else if (action.type === Const.NHL_NAME_STACK_SET_PLAYER_TO_ITEM) {
        const groups = {...state.groups};
        const items = [...groups[action.groupNumber].items];
        items[action.itemNumber].players = action.players;
        groups[action.groupNumber].items = [...items];
        state = {...state, groups, isReset: false};
    } else if (action.type === Const.NHL_NAME_STACK_IS_USED) {
        state = {...state, useStack: action.data, isReset: false};
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultStateOfNhlNameStack,
            groups: {
                [Const.NHL_NAME_STACK_FIRST_GROUP]: {
                    playersQuantity: Const.NHL_NAME_STACK_MIN_PLAYERS_QUANTITY,
                    items: [{...nhlNameStackItemTemplate}],
                },
                [Const.NHL_NAME_STACK_SECOND_GROUP]: {
                    playersQuantity: Const.NHL_NAME_STACK_MIN_PLAYERS_QUANTITY,
                    items: [{...nhlNameStackItemTemplate}],
                },
            },
            isReset: true,
        };
    }

    return state;
}

const mlbHittersStackItemTemplate = {
    team: '',
    expMin: '',
    playerIds: [],
};

const defaultStateOfHittersStack = {
    data: {
        groups: {
            [Const.FIRST_HITTER_GROUP]: {
                playersQuantity: Const.HITTERS_STACK_MIN_PLAYERS_QUANTITY,
                items: [{...mlbHittersStackItemTemplate}],
            },
            [Const.SECOND_HITTER_GROUP]: {
                playersQuantity: Const.HITTERS_STACK_MIN_PLAYERS_QUANTITY,
                items: [{...mlbHittersStackItemTemplate}],
            },
        },
        isDoubleStackMode: false,
    },
    useStack: false,
    isReset: false,
    getGroups() {
        return {...this.data.groups};
    },
    getGroup(groupNumber) {
        return {...this.data.groups[groupNumber]};
    },
    getFirstGroupItems() {
        return [...this.data.groups[Const.FIRST_HITTER_GROUP].items];
    },
    getSecondGroupItems() {
        return [...this.data.groups[Const.SECOND_HITTER_GROUP].items];
    },
    getFirstGroupPlayersQuantity() {
        return Number(this.data.groups[Const.FIRST_HITTER_GROUP].playersQuantity);
    },
    getSecondGroupPlayersQuantity() {
        return Number(this.data.groups[Const.SECOND_HITTER_GROUP].playersQuantity);
    },
    isDoubleStackModeEnabled() {
        return Boolean(this.data.isDoubleStackMode);
    },
    isEnabled() {
        return Boolean(this.useStack);
    },
};

export function hitters(state = defaultStateOfHittersStack, action) {
    state = {...state};

    if (action.type === Const.HITTERS_STACK_IS_DOUBLE_STACK_MODE) {
        state.data.isDoubleStackMode = action.data;
        state.isReset = false;
    } else if (action.type === Const.SET_HITTER_STACK_PLAYERS_IN_GROUP) {
        state.data.groups[action.groupNumber].playersQuantity = action.value;
        state.isReset = false;
    } else if (action.type === Const.HITTERS_STACK_ADD_ITEM) {
        const groups = {...state.data.groups};
        const items = [...groups[action.groupNumber].items];
        items.push({...mlbHittersStackItemTemplate});
        groups[action.groupNumber].items = [...items];

        state.data.groups = groups;
        state.isReset = false;
    } else if (action.type === Const.HITTERS_STACK_REMOVE_ITEM) {
        const groups = {...state.data.groups};
        const items = [...groups[action.groupNumber].items];
        items.splice(action.itemNumber, 1);
        groups[action.groupNumber].items = [...items];

        state.data.groups = groups;
        state.isReset = false;
    } else if (action.type === Const.HITTERS_STACK_SET_TEAM_TO_ITEM) {
        const groups = {...state.data.groups};
        const items = [...groups[action.groupNumber].items];
        items[action.itemNumber].team = action.team;
        items[action.itemNumber].playerIds = [];
        groups[action.groupNumber].items = [...items];

        state.data.groups = groups;
        state.isReset = false;
    } else if (action.type === Const.HITTERS_STACK_SET_EXPOSURE_TO_ITEM) {
        const groups = {...state.data.groups};
        const items = [...groups[action.groupNumber].items];
        items[action.itemNumber].expMin = action.exposure;
        groups[action.groupNumber].items = [...items];

        state.data.groups = groups;
        state.isReset = false;
    } else if (action.type === Const.HITTERS_STACK_SET_PLAYER_TO_ITEM) {
        const groups = {...state.data.groups};
        const items = [...groups[action.groupNumber].items];
        items[action.itemNumber].playerIds = action.playerIds;
        groups[action.groupNumber].items = [...items];

        state.data.groups = groups;
        state.isReset = false;
    } else if (action.type === Const.HITTERS_STACK_SET_DATA_FROM_STORAGE) {
        state.data = cp(action.data);
    } else if (action.type === Const.USE_HITTERS_STACK) {
        state = {...state, useStack: Boolean(action.use), isReset: false};
    } else if (action.type === Const.NON_CONTROLLED_HITTER_STACKING_IS_USED) {
        if (action.use) {
            state.useStack = false;
        }
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultStateOfHittersStack,
            data: {
                groups: {
                    [Const.FIRST_HITTER_GROUP]: {
                        playersQuantity: Const.HITTERS_STACK_MIN_PLAYERS_QUANTITY,
                        items: [{...mlbHittersStackItemTemplate}],
                    },
                    [Const.SECOND_HITTER_GROUP]: {
                        playersQuantity: Const.HITTERS_STACK_MIN_PLAYERS_QUANTITY,
                        items: [{...mlbHittersStackItemTemplate}],
                    },
                },
                isDoubleStackMode: false,
            },
            useStack: false,
            isReset: true,
        };
    }

    return state;
}

const defaultStateOfGroups = {
    data: [],
    all() {
        return [...this.data];
    },
    hasItems() {
        return !isEmpty(this.data);
    },
    getStateId() {
        return 'KeyPlayerStacking.Groups';
    },
};

export function groups(state = defaultStateOfGroups, action) {
    if (action.type === Const.SET_GROUPS_OF_STACKS) {
        state = {...state};
        state.data = [...state.data, ...action.data];
    } else if (inArray(action.type, [Const.RESET_GROUPS_OF_STACKS, Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {...defaultStateOfGroups, data: []};
    }

    return state;
}

export function teamNameStackingGroups(state = {data: []}, action) {
    if (action.type === Const.SET_TEAM_NAME_STACKING_GROUPS) {
        state = {...state};
        state.data = [...state.data, ...action.data];
    } else if (inArray(action.type, [Const.RESET_GROUPS_OF_STACKS, Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {data: []};
    }

    return state;
}

const reducers = {
    hitters,
    nhlName,
    nonControlled,
    groups,
    teamNameStackingGroups,
};

export default combineReducers(reducers);
